import { ChangeDetectionStrategy, Component, computed, inject, OnInit, output, signal } from "@angular/core";

import { Dialog } from "primeng/dialog";
import { Button } from "primeng/button";
import { Router } from "@angular/router";
import { AuthStore, AuthUrls, STORAGE_KEYS, StorageService } from "@rr/shared-data-access-core";

@Component({
  selector: "rr-data-privacy",
  imports: [Dialog, Button],
  templateUrl: "./data-privacy.component.html",
  styleUrl: "./data-privacy.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataPrivacyComponent implements OnInit {
  // DI
  readonly #router = inject(Router);
  readonly #storageService = inject(StorageService);
  readonly #authStore = inject(AuthStore);

  // I/O
  confirm = output<void>();

  // Template variables
  show = signal(false);
  dataPrivacyStorageKey = computed(
    () =>
      `${STORAGE_KEYS.accepted_data_privacy_notice}_${this.#authStore.user()?.sub}_${this.#authStore.user()?.org_id}`,
  );

  ngOnInit(): void {
    this.loadDataPrivacyNotice();
  }

  private loadDataPrivacyNotice() {
    const userAgreedInPrivacyNotice = this.#storageService.get<boolean | null>(this.dataPrivacyStorageKey()) ?? false;
    this.show.set(!userAgreedInPrivacyNotice);
  }

  onVisibleChange() {
    this.show.set(false);
  }

  onConfirmDataPrivacy(confirm: boolean) {
    this.#storageService.set(this.dataPrivacyStorageKey(), confirm);
    if (!confirm) {
      this.#router.navigate([AuthUrls.Logout]);
    }

    this.onVisibleChange();
    this.confirm.emit();
  }
}
